import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import { EditMessageContext } from "../../context/EditingMessage/EditingMessageContext";

import { TicketsContext } from "../../context/Tickets/TicketsContext";
// import { v4 as uuidv4 } from "uuid";

import toastError from "../../errors/toastError";
import { useHistory } from "react-router-dom";
import toastUtils from "../../utils/toastUtils";
import { AuthContext } from "../../context/Auth/AuthContext";
import ForwardModal from "../../components/ForwardMessageModal";
import ShowTicketOpen from "../ShowTicketOpenModal";
import AcceptTicketWithoutQueue from "../AcceptTicketWithoutQueueModal";

const MessageOptionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
  isGroup,
  queueId,
  whatsappId,
  onReactionClick,
  onMessageDeleted
}) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const editingContext = useContext(EditMessageContext);
  const setEditingMessage = editingContext?.setEditingMessage || null;
  const { setTabOpen } = useContext(TicketsContext);
  const history = useHistory();

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");
  const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] = useState(false);

  const [ticketOpen, setTicketOpen] = useState(null);

  const { showSelectMessageCheckbox,
    setShowSelectMessageCheckbox,
    selectedMessages,
    forwardMessageModalOpen,
    setForwardMessageModalOpen } = useContext(ForwardMessageContext);

  const handleSaveTicket = async (contactId) => {
    if (!contactId) return;

    try {
      const { data: ticket } = await api.post("/tickets", {
        contactId: contactId,
        userId: user?.id,
        status: "open",
        queueId: queueId,
        whatsappId: whatsappId
      });

      setTicketOpen(ticket);
      if (ticket.queueId === null) {
        setAcceptTicketWithouSelectQueueOpen(true);
      } else {
        setTabOpen("open");
        history.push(`/tickets/${ticket.uuid}`);
      }
    } catch (err) {
      console.error('❌ Erro ao criar/acessar ticket:', err);

      try {
        // Tentar parsing defensivo do erro
        let errorData = null;

        if (err.response?.data?.error) {
          // Se for string JSON, fazer parse
          if (typeof err.response.data.error === 'string') {
            errorData = JSON.parse(err.response.data.error);
          } else {
            // Se já for objeto, usar direto
            errorData = err.response.data.error;
          }
        }

        if (errorData && errorData.userId !== user?.id) {
          setOpenAlert(true);
          setUserTicketOpen(errorData.user?.name || 'Usuário desconhecido');
          setQueueTicketOpen(errorData.queue?.name || 'Fila desconhecida');
        } else if (errorData) {
          setOpenAlert(false);
          setUserTicketOpen("");
          setQueueTicketOpen("");

          // handleSelectTicket(errorData);
          setTabOpen(errorData.status);
          history.push(`/tickets/${errorData.uuid}`);
        } else {
          // Fallback se não conseguir fazer parse
          toastError(err);
        }
      } catch (parseError) {
        console.error('❌ Erro ao processar resposta do servidor:', parseError);
        toastError(err);
      }
    }
    //setLoading(false);
    handleClose();
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setOpenAlert(false);
    setUserTicketOpen("");
    setQueueTicketOpen("");
  };

  const handleSetShowSelectCheckbox = () => {
    setShowSelectMessageCheckbox(!showSelectMessageCheckbox);
    handleClose();
  };

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
      console.log('✅ Mensagem excluída:', message.id);

      // Notificar o componente pai para remover da UI
      if (onMessageDeleted) {
        onMessageDeleted(message.id);
      }

      toastUtils.success('Mensagem excluída com sucesso');
      setConfirmationOpen(false);
      handleClose();
    } catch (err) {
      console.error('❌ Erro ao excluir mensagem:', err);
      toastError(err);
      setConfirmationOpen(false);
    }
  };

  const handleEditMessage = async () => {
    if (setEditingMessage) {
      setEditingMessage(message);
      console.log('✅ Mensagem definida para edição:', message.id);
    } else {
      console.error('❌ EditMessageContext não disponível');
      toastError(new Error('Contexto de edição não disponível'));
    }
    handleClose();
  };
  // const handleForwardMessage = (msg) => {
  //   setForwardModalOpen(true);
  //   setForwardMessage(msg);
  //   handleClose();
  // };
  // const handleCloseForwardModal = () => {

  //   //setSelectedSchedule(null);
  //   setForwardModalOpen(false);
  //   handleClose();
  // };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const isWithinFifteenMinutes = () => {
    const fifteenMinutesInMilliseconds = 15 * 60 * 1000; // 15 minutos em milissegundos
    const currentTime = new Date();
    const messageTime = new Date(message.createdAt);

    // Verifica se a diferença entre o tempo atual e o tempo da mensagem é menor que 15 minutos
    return currentTime - messageTime <= fifteenMinutesInMilliseconds;
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };

  // Handler para abrir o picker de reações
  const handleReactionClick = (event) => {
    if (onReactionClick) {
      onReactionClick(event, message);
    }
    handleClose();
  };

  return (
    <>
      {acceptTicketWithouSelectQueueOpen && (
        <AcceptTicketWithoutQueue
          modalOpen={acceptTicketWithouSelectQueueOpen}
          onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
          ticket={ticketOpen}
          ticketId={ticketOpen?.id}
        />
      )}
      {openAlert && (
        <ShowTicketOpen
          isOpen={openAlert}
          handleClose={handleCloseAlert}
          user={userTicketOpen}
          queue={queueTicketOpen}
        />
      )}
      {confirmationOpen && (
        <ConfirmationModal
          title={i18n.t("messageOptionsMenu.confirmationModal.title")}
          open={confirmationOpen}
          onClose={setConfirmationOpen}
          onConfirm={handleDeleteMessage}
        >
          {i18n.t("messageOptionsMenu.confirmationModal.message")}
        </ConfirmationModal>
      )}

      {forwardMessageModalOpen && (
        <ForwardModal
          modalOpen={forwardMessageModalOpen}
          messages={selectedMessages}
          onClose={(e) => {
            setForwardMessageModalOpen(false);
            setShowSelectMessageCheckbox(false);
          }}
        />
      )}
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 'calc(100vh - 96px)',
            overflow: 'auto'
          }
        }}
      >
        {message.fromMe && (
          <MenuItem key="delete" onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        {message.fromMe && isWithinFifteenMinutes() && (
          <MenuItem key="edit" onClick={handleEditMessage}>
            {i18n.t("messageOptionsMenu.edit")}
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
        <MenuItem onClick={handleSetShowSelectCheckbox}>
          {i18n.t("messageOptionsMenu.forward")}
        </MenuItem>
        {!message.fromMe && isGroup && (
          <MenuItem onClick={() => handleSaveTicket(message?.contact?.id)}>
            {i18n.t("messageOptionsMenu.talkTo")}
          </MenuItem>
        )}
        <MenuItem onClick={handleReactionClick}>
          {i18n.t("messageOptionsMenu.addReaction") || "Adicionar Reação"} 😀
        </MenuItem>
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;